export interface FeatureBounds {
  x: number;
  y: number;
  width: number;
  height: number;
}

export class FeaturePlacer {
  private features: FeatureBounds[] = [];
  private worldHeight: number;
  private waterLevel: number;
  private defaultMargin: number = 20;

  constructor(worldHeight: number, waterLevel: number) {
    this.worldHeight = worldHeight;
    this.waterLevel = waterLevel;
  }

  addFeature(bounds: FeatureBounds): boolean {
    if (!this.canPlace(bounds, this.defaultMargin)) {
      return false;
    }
    this.features.push(bounds);
    return true;
  }

  canPlace(bounds: FeatureBounds, margin: number = this.defaultMargin): boolean {
    if (this.isInWaterZone(bounds)) {
      return false;
    }

    for (const existing of this.features) {
      if (this.overlaps(bounds, existing, margin)) {
        return false;
      }
    }

    return true;
  }

  tryPlace(generator: () => FeatureBounds | null, maxAttempts: number): FeatureBounds | null {
    for (let i = 0; i < maxAttempts; i++) {
      const bounds = generator();
      if (bounds === null) {
        continue;
      }
      if (this.canPlace(bounds)) {
        this.addFeature(bounds);
        return bounds;
      }
    }
    return null;
  }

  reset(): void {
    this.features = [];
  }

  private isInWaterZone(bounds: FeatureBounds): boolean {
    const waterTop = this.worldHeight - this.waterLevel;
    return bounds.y + bounds.height > waterTop;
  }

  private overlaps(a: FeatureBounds, b: FeatureBounds, margin: number): boolean {
    return !(
      a.x + a.width + margin <= b.x ||
      b.x + b.width + margin <= a.x ||
      a.y + a.height + margin <= b.y ||
      b.y + b.height + margin <= a.y
    );
  }
}
